"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
const react_1 = __importDefault(require("react"));
exports.Tab = (props) => {
    const { disabled = false, onClick = () => { }, selected = false, title, } = props;
    const classes = ['tab'];
    if (selected) {
        classes.push('active');
    }
    if (disabled) {
        classes.push('disabled');
    }
    return (react_1.default.createElement("div", { className: classes.join(' '), onClick: () => {
            if (!disabled) {
                onClick();
            }
        } }, title));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFiLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xheW91dC9UYWIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUdzQztBQVN6QixRQUFBLEdBQUcsR0FBZ0MsQ0FBQyxLQUFlLEVBQUUsRUFBRTtJQUVoRSxNQUFNLEVBQ0YsUUFBUSxHQUFHLEtBQUssRUFDaEIsT0FBTyxHQUFHLEdBQUcsRUFBRSxHQUFFLENBQUMsRUFDbEIsUUFBUSxHQUFHLEtBQUssRUFDaEIsS0FBSyxHQUNSLEdBQUcsS0FBSyxDQUFDO0lBRVYsTUFBTSxPQUFPLEdBQUcsQ0FBRSxLQUFLLENBQUUsQ0FBQztJQUUxQixJQUFJLFFBQVEsRUFBRTtRQUNWLE9BQU8sQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUM7S0FDMUI7SUFDRCxJQUFJLFFBQVEsRUFBRTtRQUNWLE9BQU8sQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUM7S0FDNUI7SUFFRCxPQUFPLENBQ0gsdUNBQUssU0FBUyxFQUFFLE9BQU8sQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsT0FBTyxFQUFFLEdBQUcsRUFBRTtZQUM3QyxJQUFJLENBQUMsUUFBUSxFQUFFO2dCQUNYLE9BQU8sRUFBRSxDQUFDO2FBQ2I7UUFDTCxDQUFDLElBQ0ssS0FBSyxDQUNMLENBQ1QsQ0FBQztBQUVOLENBQUMsQ0FBQyJ9